import { render } from "./CardResult.vue?vue&type=template&id=a5eb0500&scoped=true"
import script from "./CardResult.vue?vue&type=script&lang=js"
export * from "./CardResult.vue?vue&type=script&lang=js"

import "./CardResult.vue?vue&type=style&index=0&id=a5eb0500&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5eb0500"]])

export default __exports__